import React, { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

import { TextProps } from './@types/textProps';
import { SText } from './index.styled';

function Text(
	props: PropsWithChildren<
		TextProps & DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>
	>
): JSX.Element {
	const {
		align,
		as = 'p',
		children,
		className,
		color,
		colorDarkMode,
		decoration,
		transform,
		size = 'paragraph',
		weight,
		hasSensitiveContent,
		...other
	} = props;
	const defaultWeight = ['h1', 'h2', 'h3', 'h4', 'h5', 'strong'].includes(as)
		? 600
		: as === 'h6'
			? 500
			: 400;

	return (
		<SText
			as={as}
			align={align}
			className={className}
			color={color}
			colorDarkMode={colorDarkMode}
			decoration={decoration}
			transform={transform}
			size={size}
			weight={weight || defaultWeight}
			{...(hasSensitiveContent && { 'data-clarity-mask': true })}
			{...other}
		>
			{children}
		</SText>
	);
	return <></>;
}

export default Text;
